import { useEffect, useState } from "react";
import Parse from "../api/ApiConfig";
import { toast } from "react-toastify";

export const useUploadFile = (fileToUpload) => {
	const [loading, setLoading] = useState(false);
	const [fileUploadSuccess, setFileUploadSuccess] = useState(null);

	useEffect(() => {
		if (!fileToUpload) {
			return;
		}
		setLoading(true);
		const fileName = fileToUpload?.name;
		const parseFile = new Parse.File(fileName, fileToUpload);

		parseFile
			.save()
			.then((d) => {
				// eslint-disable-next-line no-undef
				console.log(d);
				setFileUploadSuccess({ fileName, url: d?._url });
				setLoading(false);
			})
			.catch((error) => {
				// eslint-disable-next-line no-undef
				console.log(error);
				setLoading(false);
				toast.error("Failed to upload file");
			});
	}, [fileToUpload]);

	return { loading, fileUploadSuccess };
};
